import { LSFetch } from '../helpers'

export const getLandingPageBanners = params => {
    return LSFetch.get('/banner/landingPage', { params });
  }